export default "__VITE_ASSET__858c7684__"